<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Import CSV Files for JWD
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <import-file-form/>

                <template v-if="updates.length > 0">
                    <jet-section-border/>

                    <div class="flex items-center mb-6">
                        <h3 class="text-lg font-medium text-gray-900">Information</h3>

                        <div class="ml-auto">
                            <jet-input
                                id="search"
                                type="text"
                                placeholder="Filter..."
                                class="block w-full"
                                v-model="search"
                            />
                        </div>
                    </div>

                    <table
                        class="w-full whitespace-nowrap rounded bg-white divide-y divide-gray-300 overflow-hidden shadow">
                        <thead class="bg-gray-900">
                        <tr class="text-white">
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-left">File</th>
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-right">Last Update</th>
                        </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-200">
                        <tr v-for="(update, idx) in searchResults" :key="idx" :class="{'bg-gray-100' : idx % 2 !== 0}">
                            <td class="px-6 py-4">
                                {{ update.file }}
                            </td>

                            <td class="px-6 py-4 text-right">
                                {{ new Date(update.time * 1000).toLocaleString() }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import ImportFileForm from './ImportFileForm';
import JetInput from '@/Jetstream/Input';
import JetSectionBorder from '@/Jetstream/SectionBorder';

export default {
    components: {
        ImportFileForm,
        AppLayout,
        JetInput,
        JetSectionBorder,
    },

    props: ['updates'],

    data()
    {
        return {
            search: null,
        };
    },

    computed: {
        searchResults()
        {
            if (this.search === null) {
                return this.updates;
            }

            return this.updates.filter(e => e.file.includes(this.search));
        },
    },
};
</script>
